(() => {
  const selector = '[data-lufasnd-header-dropdown]';

  const closeDropdown = (dropdown) => {
    dropdown.removeAttribute('open');
  };

  const closeOtherDropdowns = (current) => {
    document.querySelectorAll(`${selector}[open]`).forEach((dropdown) => {
      if (dropdown !== current) closeDropdown(dropdown);
    });
  };

  document.addEventListener('toggle', (event) => {
    const dropdown = event.target;
    if (!(dropdown instanceof HTMLDetailsElement) || !dropdown.matches(selector) || !dropdown.open) return;
    closeOtherDropdowns(dropdown);
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest(selector)) return;
    document.querySelectorAll(`${selector}[open]`).forEach(closeDropdown);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${selector}[open]`).forEach((dropdown) => {
      closeDropdown(dropdown);
      dropdown.querySelector('summary')?.focus();
    });
  });
})();
